import { Checkbox, Stack, Text } from '@chakra-ui/react'
import { ProposalDecisionMode } from '@rolebase/shared/model/proposal'
import React from 'react'
import { useTranslation } from 'react-i18next'

// Consent is the base mode and stays open whatever happens (the DB says so
// too). The others are opened one by one by an admin.
const optionalModes: ProposalDecisionMode[] = [
  'unanimity',
  'simpleMajority',
  'absoluteMajority',
]

interface Props {
  value: ProposalDecisionMode[]
  onChange: (modes: ProposalDecisionMode[]) => void
  isDisabled?: boolean
}

export default function ProposalDecisionModesCheckboxes({
  value,
  onChange,
  isDisabled,
}: Props) {
  const { t } = useTranslation()

  const handleToggle =
    (mode: ProposalDecisionMode) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const modes = event.target.checked
        ? [...value, mode]
        : value.filter((m) => m !== mode)
      onChange(modes)
    }

  return (
    <Stack spacing={2}>
      <Checkbox isChecked isDisabled>
        {t('ProposalModal.decisionMode_consent')}
        <Text as="span" fontSize="sm" ml={2} opacity={0.7}>
          {t('OrgEditModal.proposalDecisionModeAlways')}
        </Text>
      </Checkbox>

      {optionalModes.map((mode) => (
        <Checkbox
          key={mode}
          isChecked={value.includes(mode)}
          onChange={handleToggle(mode)}
          isDisabled={isDisabled}
        >
          {t(`ProposalModal.decisionMode_${mode}`)}
        </Checkbox>
      ))}
    </Stack>
  )
}
